import { useQuery } from '@tanstack/react-query';

import PackagesService from '~/services/PackagesService';

export const packageSchemaQueryKeys = {
  all: ['packages', 'schema'] as const,
  detail: (offerId?: string) => [...packageSchemaQueryKeys.all, offerId] as const,
};

export function useGetPackageSchema(offerId?: string) {
  return useQuery({
    queryKey: packageSchemaQueryKeys.detail(offerId),
    queryFn: async () => {
      const response = await PackagesService.getPackageSchema(offerId);
      return response.patch.body.schema;
    },
    enabled: !!offerId,
  });
}
